import { render, staticRenderFns } from "./PricingCategoriesEditor.vue?vue&type=template&id=b75dbbba&scoped=true"
import script from "./PricingCategoriesEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./PricingCategoriesEditor.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PricingCategoriesEditor.vue?vue&type=style&index=0&id=b75dbbba&prod&lang=scss&scoped=true"
import style1 from "./PricingCategoriesEditor.vue?vue&type=style&index=1&id=b75dbbba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b75dbbba",
  null
  
)

export default component.exports